import React, {FC, memo, useEffect} from 'react'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import TextField from '@pixel/core/TextField'
import {styled} from "@pixel/core/styles";
import ActionValue from "./ActionValue";

interface ActionFieldProps {
    actionFieldIndex: number
    actions: any;
}

const ActionFieldSection = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(2),
}))

const ActionField: FC<ActionFieldProps> = ({
    actionFieldIndex,
    actions,
}) => {

    const { control, setValue } = useFormContext()

    const actionType = useWatch({ name: `companyActions.${actionFieldIndex}.actionType`, control })

    useEffect(() =>{
        if (actionType !== undefined) {
            const actionField = actions.find((el: any) => el.actionType === actionType ).automationActionFields[0].actionField
            setValue(`companyActions.${actionFieldIndex}.actionFields.0.actionField`, actionField)
        }
    }, [actionType, setValue])

    if (actionType === undefined) return null

    return (
        <>
            <ActionFieldSection>
                <Controller
                    control={control}
                    name={`companyActions.${actionFieldIndex}.actionFields.0.actionField`}
                    render={({ field, }) => (
                        <TextField
                            {...field}
                            hidden={true}
                        >
                        </TextField>
                    )}
                />
            </ActionFieldSection>
            <ActionValue actionValueIndex={actionFieldIndex}></ActionValue>
        </>
    )
}

export default memo(ActionField)
